export const COMPANY_NAME = 'Rovo Trips Private Limited';
export const OFFICIAL_EMAIL_ID = 'team@rovotrips.com';
export const MY_RASOI_NAME = 'My Rasoi';
export const OFFICIAL_PHONE_NUMBER = '+919599523882';
export const MY_RASOI_WEBSITE = {
	DISPLAY_NAME: 'www.myrasoi.in',
	URL: 'https://www.myrasoi.in',
};

export const RUPEES_SYMBOL = '₹';
export const MENU_BASE_URL = 'https://menu.myrasoi.in';

export const MY_RASOI_APP_URL = {
	PLAY_STORE: 'https://play.google.com/store/apps/details?id=com.myrasoi',
};

export const CURRENT_YEAR = '2021';

export const FOOD_TYPE = {
	VEG_FOOD_TYPE: 'veg',
	NON_VEG_FOOD_TYPE: 'nonVeg',
	NO_FOOD_TYPE: 'none',
};

export const DEFAULT_COUNTRY = {
	countryCode: 'IN',
	currency: 'INR',
	callingCode: '91',
	region: 'Asia',
	subregion: 'Southern Asia',
	flag: 'flag-in',
	name: 'India',
	currencySymbol: RUPEES_SYMBOL,
};

export const ITEM_TYPE = {
	ITEM: 'item',
	EXTRA: 'extra',
	COUPON_CODE: 'couponCode',
};

export const EXPIRY_DAYS_FOR_TIME_ELAPSED = 7;

export const DEVICE_DETAILS = {
	DEVICE_TYPE_WEB: 'web',
};

export const MENU_PLACEHOLDER_IMAGE =
	'https://rovotrips.s3.ap-south-1.amazonaws.com/MyRasoi/placeholders/menu.png';
export const FOOD_ITEM_PLACEHOLDER_IMAGE =
	'https://rovotrips.s3.ap-south-1.amazonaws.com/MyRasoi/placeholders/foodItem.png';
